/* free-book.js — Free Book Program widget logic
 * Paste this file into your Shopify theme: Assets → Add a new asset → free-book.js
 */
(function () {
  'use strict';

  var cfg = window.__fbConfig || {};
  var API_BASE = (cfg.apiBase || '').replace(/\/$/, '');
  var DONORBOX_URL = cfg.donorboxUrl || '#';
  var POLL_INTERVAL_MS = 20000; // 20 seconds
  var metricsPoller = null;
  var lastMetrics = null;
  var countersAnimated = false;

  /* ─── Utility ─────────────────────────────────────────────── */

  function $(id) { return document.getElementById(id); }

  function formatNumber(n) {
    return Number(n).toLocaleString();
  }

  function formatDollars(n) {
    return '$' + formatNumber(n);
  }

  /* Animates a numeric element from its current displayed value to `target`. */
  function animateTo(el, target) {
    if (!el) return;
    var start = parseInt(el.textContent.replace(/[^0-9]/g, ''), 10) || 0;
    var diff = target - start;
    if (diff === 0) return;
    var duration = 800;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = Math.round(start + diff * ease);
      el.textContent = formatNumber(current);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = formatNumber(target);
    }
    requestAnimationFrame(step);
  }

  /* Percent text that stays honest at both ends of the scale: a single claim
     out of thousands is not "0%", and 99.7% of books gone is not "100%". */
  function formatPct(p) {
    if (p <= 0) return '0%';
    if (p >= 100) return '100%';
    if (p < 1) return '<1%';
    if (p > 99) return '99%';
    if (p < 10) return (Math.round(p * 10) / 10) + '%';
    return Math.round(p) + '%';
  }

  /* ─── Metrics rendering ────────────────────────────────────── */

  function renderMetrics(m) {
    var container = $('fb-metrics');
    if (!container) return;

    var funded = m.books_funded > 0 ? m.books_funded : 0;
    var pctExact = funded > 0
      ? Math.max(0, Math.min(100, (m.books_claimed / funded) * 100))
      : 0;
    // Any real claim must be visible. 7 books of 5,000 is 0.14% — a rounded
    // bar would render 0% wide and look like nothing had happened.
    var barWidth = (m.books_claimed > 0 && pctExact < 1.5) ? 1.5 : pctExact;
    var pctText = formatPct(pctExact);

    // First load: build HTML skeleton, then animate
    if (!lastMetrics) {
      container.innerHTML =
        '<div class="fb-stats">' +
          '<div class="fb-stat">' +
            '<span class="fb-stat-value" id="fb-raised">0</span>' +
            '<span class="fb-stat-label">Money Raised</span>' +
          '</div>' +
          '<div class="fb-stat">' +
            '<span class="fb-stat-value" id="fb-claimed">0</span>' +
            '<span class="fb-stat-label">Books Claimed</span>' +
          '</div>' +
          '<div class="fb-stat">' +
            '<span class="fb-stat-value" id="fb-available">0</span>' +
            '<span class="fb-stat-label">Books Available</span>' +
          '</div>' +
        '</div>' +
        '<div class="fb-progress" id="fb-progress">' +
          '<div class="fb-progress-head">' +
            '<span class="fb-progress-head-label">Books claimed</span>' +
            '<span class="fb-progress-head-pct" id="fb-progress-pct">0%</span>' +
          '</div>' +
          '<div class="fb-progress-track" id="fb-progress-track" role="progressbar" ' +
               'aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
            '<div class="fb-progress-bar" id="fb-progress-bar"></div>' +
            '<span class="fb-progress-tick" style="left:25%"></span>' +
            '<span class="fb-progress-tick" style="left:50%"></span>' +
            '<span class="fb-progress-tick" style="left:75%"></span>' +
          '</div>' +
          '<div class="fb-progress-foot">' +
            '<span class="fb-progress-label" id="fb-progress-label"></span>' +
            '<span class="fb-progress-remain" id="fb-progress-remain"></span>' +
          '</div>' +
        '</div>';
    }

    // Animate numbers on first load, update directly on polls
    var raisedEl = $('fb-raised');
    var claimedEl = $('fb-claimed');
    var availableEl = $('fb-available');
    var bar = $('fb-progress-bar');
    var label = $('fb-progress-label');

    if (!countersAnimated) {
      // Show raised_dollars immediately — animating it from 0 up gives the false
      // impression that money is being raised in real-time (it only changes via
      // DonorBox webhooks, never because of claims).
      if (raisedEl) raisedEl.textContent = formatDollars(m.raised_dollars);
      animateTo(claimedEl, m.books_claimed);
      animateTo(availableEl, m.books_available);
    } else {
      if (raisedEl) raisedEl.textContent = m.raised_dollars;
      if (claimedEl) claimedEl.textContent = formatNumber(m.books_claimed);
      if (availableEl) availableEl.textContent = formatNumber(m.books_available);
    }

    // Format with $ / commas after animation set the raw number.
    // countersAnimated is checked BEFORE being set to true so the delay is
    // correctly 850 ms on the very first render (letting the 800 ms animation
    // finish) and 0 ms on every subsequent poll update.
    if (raisedEl) {
      setTimeout(function () {
        if (raisedEl) raisedEl.textContent = formatDollars(m.raised_dollars);
      }, countersAnimated ? 0 : 850);
      setTimeout(function () {
        if (claimedEl) claimedEl.textContent = formatNumber(m.books_claimed);
        if (availableEl) availableEl.textContent = formatNumber(m.books_available);
      }, countersAnimated ? 0 : 850);
    }

    countersAnimated = true;

    if (bar) bar.style.width = barWidth + '%';
    if (label) label.textContent = formatNumber(m.books_claimed) + ' of ' + formatNumber(m.books_funded) + ' books claimed';

    var pctEl = $('fb-progress-pct');
    if (pctEl) pctEl.textContent = pctText;

    var remainEl = $('fb-progress-remain');
    if (remainEl) {
      remainEl.textContent = m.sold_out
        ? 'All books claimed'
        : formatNumber(m.books_available) + ' remaining';
    }

    var wrap = $('fb-progress');
    if (wrap) wrap.className = 'fb-progress' + (m.sold_out ? ' is-soldout' : '');

    // Screen readers get the real numbers, not just the rounded percentage.
    var track = $('fb-progress-track');
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.round(pctExact * 10) / 10));
      track.setAttribute('aria-valuetext',
        formatNumber(m.books_claimed) + ' of ' + formatNumber(m.books_funded) +
        ' books claimed (' + pctText + ')');
    }

    // Milestone pulse at 25 / 50 / 75 / 100 %
    if (bar && lastMetrics) {
      var prevPct = lastMetrics.books_funded > 0
        ? Math.max(0, Math.min(100, (lastMetrics.books_claimed / lastMetrics.books_funded) * 100))
        : 0;
      var milestones = [25, 50, 75, 100];
      for (var mi = 0; mi < milestones.length; mi++) {
        if (prevPct < milestones[mi] && pctExact >= milestones[mi]) {
          bar.classList.remove('fb-milestone');
          void bar.getBoundingClientRect();
          bar.classList.add('fb-milestone');
          setTimeout(function () { bar.classList.remove('fb-milestone'); }, 750);
          break;
        }
      }
    }

    // Handle sold-out state
    if (m.sold_out) {
      showSoldOut();
    }

    lastMetrics = m;
  }

  function showSoldOut() {
    var claimBtn = $('fb-show-claim-btn');
    if (claimBtn) {
      claimBtn.textContent = 'All books claimed — donate to fund more';
      claimBtn.className = 'fb-btn fb-btn-soldout';
      claimBtn.setAttribute('onclick', '');
      claimBtn.onclick = null;
    }
    var claimForm = $('fb-claim');
    if (claimForm) claimForm.style.display = 'none';
  }

  function fetchMetrics() {
    if (!API_BASE) {
      renderZeroMetrics();
      return;
    }
    fetch(API_BASE + '/metrics', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (m) {
        // Treat missing/null fields as zero
        renderMetrics({
          books_funded:    m.books_funded    || 0,
          books_claimed:   m.books_claimed   || 0,
          books_available: m.books_available || 0,
          raised_dollars:  m.raised_dollars  || 0,
          sold_out:        m.sold_out        || false,
        });
      })
      .catch(function (err) {
        console.warn('Free Book: metrics fetch failed', err);
        if (!lastMetrics) renderZeroMetrics();
      });
  }

  function renderZeroMetrics() {
    renderMetrics({ books_funded: 0, books_claimed: 0, books_available: 0, raised_dollars: 0, sold_out: false });
  }

  /* ─── Claim form ────────────────────────────────────────────── */

  window.fbShowClaimForm = function () {
    var form = $('fb-claim');
    var btn = $('fb-show-claim-btn');
    if (form) form.style.display = '';
    if (btn) btn.style.display = 'none';
    var emailInput = $('fb-email');
    if (emailInput) emailInput.focus();
  };

  window.fbSubmitClaim = function () {
    var msg = $('fb-form-message');
    var email = ($('fb-email') || {}).value || '';
    var firstName = ($('fb-first-name') || {}).value || '';
    var lastName = ($('fb-last-name') || {}).value || '';
    var school = ($('fb-school') || {}).value || '';
    var website = ($('fb-website') || {}).value || ''; // honeypot
    var quantityEl = $('fb-quantity');
    var quantity = quantityEl ? parseInt(quantityEl.value, 10) || 1 : 1;

    // The form is submitted via a type="button" onclick handler and the <form> has
    // onsubmit="return false;", so the browser never runs native `required`
    // validation. These checks are the only client-side enforcement there is.
    // Validated in form order so the visitor fixes the topmost problem first.
    clearInvalid();
    if (!school.trim()) {
      flagInvalid('fb-school');
      setMessage(msg, 'Please enter your school, parish, or group name.', 'error');
      return;
    }
    if (!email.trim()) {
      flagInvalid('fb-email');
      setMessage(msg, 'Please enter your email address.', 'error');
      return;
    }

    var submitBtn = document.querySelector('.fb-submit-btn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Reserving your books…';
    }
    setMessage(msg, '', '');

    fetch(API_BASE + '/claim', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        first_name: firstName,
        last_name: lastName,
        school: school,
        website: website,
        quantity: quantity,
        source: 'shopify_page',
      }),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { status: r.status, data: data }; });
      })
      .then(function (res) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Get My Free Books';
        }

        if (res.status === 200 && res.data.ok) {
          showSuccess(res.data);
        } else if (res.status === 409 && res.data.error === 'claim_cooldown') {
          var eligibleDate = new Date(res.data.eligible_at);
          var formatted = eligibleDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
          setMessage(
            msg,
            'You already claimed books with this email. You can claim again on <strong>' + formatted + '</strong>.',
            'error'
          );
        } else if (res.status === 409 && res.data.error === 'insufficient_stock') {
          var avail = res.data.available_sets || 0;
          setMessage(
            msg,
            'Only ' + avail + ' set' + (avail === 1 ? '' : 's') + ' available right now. Please select ' + avail + ' or fewer.',
            'error'
          );
        } else if (res.status === 409) {
          // Sold out
          showSoldOut();
          var claimForm = $('fb-claim');
          if (claimForm) claimForm.style.display = 'none';
        } else if (res.status === 429) {
          setMessage(msg, 'Too many attempts. Please wait a moment and try again.', 'error');
        } else if (res.status === 400) {
          // Name the field the server actually rejected rather than always
          // blaming the email address.
          var fieldErrors = (res.data.details && res.data.details.fieldErrors) || {};
          if (fieldErrors.school) {
            flagInvalid('fb-school');
            setMessage(msg, 'Please enter your school, parish, or group name.', 'error');
          } else if (fieldErrors.email) {
            flagInvalid('fb-email');
            setMessage(msg, 'Please enter a valid email address.', 'error');
          } else {
            setMessage(msg, 'Please check your details and try again.', 'error');
          }
        } else {
          setMessage(
            msg,
            'Something went wrong. Please try again or email us at <a href="mailto:hhohman@extraordinarymission.com">hhohman@extraordinarymission.com</a>.',
            'error'
          );
        }
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Get My Free Books';
        }
        setMessage(
          msg,
          'Connection error. Please check your internet and try again.',
          'error'
        );
      });
  };

  function setMessage(el, html, type) {
    if (!el) return;
    el.innerHTML = html;
    el.className = 'fb-message' + (type ? ' ' + type : '');
  }

  /* Highlights a required field that failed validation and moves focus to it. */
  function flagInvalid(id) {
    var el = $(id);
    if (!el) return;
    el.classList.add('fb-invalid');
    el.focus();
  }

  function clearInvalid() {
    var form = $('fb-claim-form');
    if (!form) return;
    var flagged = form.querySelectorAll('.fb-invalid');
    for (var i = 0; i < flagged.length; i++) flagged[i].classList.remove('fb-invalid');
  }

  function launchConfetti() {
    var colors = ['#7B3B3B', '#c89090', '#ffffff', '#f5f0eb', '#d4a0a0', '#e8d5c4'];
    var formCol = document.querySelector('.fb-form-col');
    var originX = window.innerWidth / 2;
    var originY = window.innerHeight / 2;
    if (formCol) {
      var rect = formCol.getBoundingClientRect();
      originX = rect.left + rect.width / 2;
      originY = rect.top + rect.height / 3;
    }
    for (var i = 0; i < 72; i++) {
      (function () {
        var el = document.createElement('div');
        var size = Math.random() * 9 + 4;
        var isCircle = Math.random() > 0.4;
        el.style.cssText =
          'position:fixed;width:' + size + 'px;height:' + (isCircle ? size : (size * 0.4 + 2)) + 'px;' +
          'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
          'border-radius:' + (isCircle ? '50%' : '2px') + ';' +
          'pointer-events:none;z-index:99999;' +
          'left:' + originX + 'px;top:' + originY + 'px;' +
          'transform:translate(-50%,-50%);';
        document.body.appendChild(el);
        var angle = Math.random() * Math.PI * 2;
        var speed = Math.random() * 280 + 80;
        var vx = Math.cos(angle) * speed;
        var vy = Math.sin(angle) * speed - 160;
        var gravity = 500;
        var duration = 1.0 + Math.random() * 0.8;
        var startTime = null;
        function frame(ts) {
          if (!startTime) startTime = ts;
          var t = (ts - startTime) / 1000;
          if (t > duration) { el.remove(); return; }
          var x = originX + vx * t;
          var y = originY + vy * t + 0.5 * gravity * t * t;
          el.style.left = x + 'px';
          el.style.top = y + 'px';
          el.style.opacity = Math.max(0, 1 - t / duration);
          el.style.transform = 'translate(-50%,-50%) rotate(' + (t * 200) + 'deg)';
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      })();
    }
  }

  function typewriterCode(el, text) {
    el.textContent = '';
    var i = 0;
    function tick() {
      if (i < text.length) {
        el.textContent += text[i++];
        setTimeout(tick, 55);
      } else {
        el.style.borderColor = 'rgba(255,255,255,0.5)';
        el.style.boxShadow = '0 0 24px rgba(255,255,255,0.18)';
      }
    }
    tick();
  }

  function resetSvgAnimations(container) {
    // Reset SVG stroke animations by toggling the class off and back on
    ['fb-svg-circle-anim', 'fb-svg-check-anim'].forEach(function (cls) {
      container.querySelectorAll('.' + cls).forEach(function (el) {
        el.classList.remove(cls);
        void el.getBoundingClientRect(); // force reflow
        el.classList.add(cls);
      });
    });
  }

  function showSuccess(data) {
    var claimSection = $('fb-claim');
    var successSection = $('fb-success');

    // Fade-out form panel
    if (claimSection) {
      claimSection.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      claimSection.style.opacity = '0';
      claimSection.style.transform = 'scale(0.97) translateY(-8px)';
      setTimeout(function () { claimSection.style.display = 'none'; }, 320);
    }

    // Confetti burst
    launchConfetti();

    // Spring-in success panel after form fades
    setTimeout(function () {
      if (successSection) {
        successSection.style.display = 'block';
        successSection.style.animation = 'none';
        void successSection.offsetHeight; // force reflow
        resetSvgAnimations(successSection);
        successSection.style.animation = 'fb-success-enter 0.65s cubic-bezier(0.34,1.56,0.64,1) both';
      }
    }, 280);

    // Refresh metrics immediately so books_available decrements right away
    setTimeout(fetchMetrics, 600);
  }

  /* ─── Init ──────────────────────────────────────────────────── */

  function init() {
    if (!API_BASE) {
      console.warn('Free Book: RAILWAY_API_BASE is not set in section settings.');
      return;
    }
    fetchMetrics();
    metricsPoller = setInterval(fetchMetrics, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
